<script>
  import InlineSvg from '../elements/InlineSvg.svelte';
  import NewsletterSidebarItem from './NewsletterSidebarItem.svelte';

  let activeItem;
  function onNewsletterClick(i) {
    activeItem = i;
  }
</script>

<div class="newsletter-sidebar">
  <div class="header">
    <h4>Newsletter Inbox</h4>
    <span>12 Issues, 3 unread</span>
    <InlineSvg
      src="/img/icon/sort.svg"
      width="20px"
      push={{ position: 'absolute', top: '26px', right: '16px' }}
    />
  </div>
  {#each Array(12) as _, i}
    <NewsletterSidebarItem
      {i}
      active={i === activeItem}
      on:click={() => onNewsletterClick(i)}
    />
  {/each}
</div>

<style lang="scss">
  @import '../../styles/mixins';

  .newsletter-sidebar {
    height: 100%;
    flex: 0 0 304px;
    overflow: overlay;
    box-shadow: inset -1px 0px 0px var(--color-blue-gray--100);
    padding-bottom: 32px;
    position: relative;
    transition: all 0.1s ease-in;

    .header {
      display: flex;
      flex-direction: column;
      justify-content: center;
      width: 100%;
      padding: 16px;
      border-bottom: 1px solid var(--color-blue-gray--100);

      h4 {
        @include font(Semibold);
        font-size: 18px;
        line-height: 120%;
        color: var(--color-blue-gray--800);
        margin-bottom: 4px;
      }

      span {
        @include font(Medium);
        font-size: 11px;
        line-height: 130%;
        color: var(--color-blue-gray--400);

        & + :global(.svg-wrapper line) {
          stroke: var(--color-blue-gray--400);
        }

        & + :global(.svg-wrapper circle) {
          fill: var(--color-blue-gray--100);
        }
      }
    }
  }

  :global(.dark-mode) {
    .newsletter-sidebar {
      box-shadow: inset -1px 0px 0px var(--color-blue-gray--800);

      .header {
        border-bottom: 1px solid var(--color-blue-gray--800);

        h4 {
          color: var(--color-blue-gray--100);
        }

        span {
          color: var(--color-blue-gray--300);

          & + :global(.svg-wrapper line) {
            stroke: var(--color-blue-gray--200);
          }

          & + :global(.svg-wrapper circle) {
            fill: var(--color-blue-gray--500);
          }
        }
      }
    }
  }
</style>
